import React from "react";
import { config, getProduct } from "../config";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Primitives";

export default function Boutique() {
  const kit = getProduct("kit");
  const rest = config.products.filter((p) => p.id !== "kit");
  return (
    <main data-testid="boutique-page" className="section">
      <div className="wrap">
        <Reveal>
          <h1 className="title-xl" style={{ fontSize: "clamp(36px,8vw,64px)" }}>LA BOUTIQUE.</h1>
          <p style={{ color: "var(--text-muted)", marginTop: 12 }}>Quatre produits. Rien de plus, rien de superflu.</p>
        </Reveal>
        <div style={{ marginTop: 40 }}>
          <Reveal><ProductCard product={kit} wide badge="Le produit phare" /></Reveal>
          <div style={{ display: "grid", gap: 20, gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", marginTop: 20 }}>
            {rest.map((p, i) => (<Reveal key={p.id} delay={i * 0.06}><ProductCard product={p} /></Reveal>))}
          </div>
        </div>
      </div>
    </main>
  );
}
